module.exports = __webpack_public_path__ + "img/lavanguardia.cdcb0135.svg";